import { UserRole } from "@/types";

export const HEALTH_INSURANCE_ID = "7";

export const ROLE_TO_ROUTES: { [key: string]: string[] } = {
  [UserRole.ADMIN]: ["/licencing-admin"],
  [UserRole.ADMINCOUNCIL]: ["/licencing-admin"],
  [UserRole.ENDUSER]: ["/end-user-account"],
  [UserRole.VERIFIER]: ["/approvalofficesaccount"],
  [UserRole.FIRSTREVIEWER]: ["/approvalofficesaccount"],
  [UserRole.SECONDREVIEWER]: ["/approvalofficesaccount"],
  [UserRole.APPROVER]: ["/approvalofficesaccount"],
  [UserRole.INVIGILATOR]: ["/invigilator-account"],
  [UserRole.EXAMINER]: ["/examiner-account"],
};
